"use client";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { env } from "@ept/env/src/env-frontend";
import React from "react";
export function PHProvider({
  children
}: {
  children: React.ReactNode;
}) {
  React.useEffect(() => {
    posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: env.NEXT_PUBLIC_POSTHOG_HOST
    });
  }, []);
  return <PostHogProvider client={posthog} data-sentry-element="PostHogProvider" data-sentry-component="PHProvider" data-sentry-source-file="PHProvider.tsx">{children}</PostHogProvider>;
}